import React, { useState, useEffect } from 'react';
import * as Util from './../data/General';
import WhatsApp from '../components/html/WhatsApp';
import Button from '../components/html/Button';
import CreateWhatsApp from '../components/html/CreateWhatsApp';

function ContentSid(props) {
    const { setCS, setWA, selectedId=null } = props;
    const [sids, setSids] = useState(null);
    const [isCreate, setCreate] = useState(false);
    const [selected, setSelected] = useState(null);
    const [search, setSearch] = useState("");
    const isOK = (data) => {
        
        if(data && data.code === "200"){
            let contentSid = JSON.parse(data.data);
            setSids(contentSid);
            if(selectedId){
                Object.keys(contentSid).map((item) => {
                    if(contentSid[item].id === selectedId){
                        let wa = contentSid[item];
                        setSelected(wa);
                        setCS(wa.sid);
                        setWA(wa);
                    }
                });
            }
        }
    }

    const isError = (error) => {

    }

    useEffect(() => {
        if(sids === null){
            Util.getContentSid("",isOK, isError);
        }
    }, [selected]);

    const click = (wa) => {
        setSelected(wa);
        setCS(wa.sid);
        setWA(wa);
    }
    const createWA = () => {
        setSelected(null);
        setCS("");
        Util.getContentSid("&update=yes",isOK, isError);
        setCreate(!isCreate);
    }
    const updateList = () => {
        setSelected(null);
        Util.getContentSid("&update=yes",isOK, isError);
    }

    const deleteContent = (wa) => {
        window.confirm(Util.getMessage("confirm_delete_sid") +" "+ wa.name + "?") && Util.deleteContent(wa.id, updateList, isError);
    }


    return (
        <div>
            <div className='content-flex space-between'>
                {Util.getMessage("contentSid_table")} 
                <div className='content-flex space-between'>
                    {!isCreate ? (<input type="search" value={search} onChange={(e) => setSearch(e.target.value)} placeholder={Util.getMessage("search_products")} className="search-wa" />) : null }
                    <Button value={Util.getMessage(isCreate ? "Cancel" : "create")}  type="primary" onClick={() => setCreate(!isCreate)}/>
                </div>
            </div>
            {!isCreate ? (
                <>
                    <div className='list-messages'>
                        {sids && Object.keys(sids).map((item, key) => (
                            <div key={key}>
                                {((search === "" || sids[item].name.toLowerCase().includes(search.toLowerCase())) && sids[item].view === "1") ? (
                                    <div className='cont-wa-item'>
                                        <div className='delete' onClick={() => deleteContent(sids[item])}>X</div>
                                        <WhatsApp message={sids[item]} click={click} isSelected = {selected === sids[item]} isName={true}/>
                                    </div>
                                ) : null }
                            </div>
                        ))}
                    </div>
                </>
            ) : (
                <CreateWhatsApp oncreate={createWA}/>
            )}
        </div>
    );
}
    
export default ContentSid;
